import { useAtom } from "jotai";
import { currencyAtom } from "./currencyAtom";
import { ISupportedCurrency } from "@/api/AppApi/services/company/interfaces/ICompany";

export const useCurrencyCalc = ({ enable }: { enable: boolean }) => {
  const [currency] = useAtom(currencyAtom);
  const { exchange_rate, decimal_digits } = currency;
  const rate = enable && exchange_rate > 0 ? exchange_rate : 1;
  const fixed = exchange_rate > 0 ? decimal_digits : 3;

  const convertToCurrentCurrency = (
    price: number,
    forcedCurrency?: ISupportedCurrency,
    _roundPrice: boolean = false,
  ) => {
    const { exchange_rate } = forcedCurrency ?? {};

    // const DecimalDigits = !forcedCurrency ? decimal_digits : decimalDigits ?? 3;

    const Rate = !forcedCurrency
      ? rate
      : enable && !!exchange_rate && exchange_rate > 0
      ? exchange_rate
      : 1;
    return price * Rate;
  };

  const getPriceString = (
    price: number,
    forcedCurrency?: ISupportedCurrency,
    roundPrice: boolean = false,
  ) => {
    const { decimal_digits } = forcedCurrency ?? {};
    const Fixed = !forcedCurrency ? fixed : decimal_digits;
    return convertToCurrentCurrency(price, forcedCurrency, roundPrice).toFixed(
      Fixed,
    );
  };

  return { currency, convertToCurrentCurrency, getPriceString };
};
// function RoundPrice(amount: number, decimalDigits: number): number {
//   const currencyRules: { [key: number]: number } = {
//     3: 0.01,
//     2: 0.01,
//   };
//   const roundingFactor =
//     currencyRules[decimalDigits] || Math.pow(10, -decimalDigits);

//   return Math.ceil(amount / roundingFactor) * roundingFactor;
// }
